module.exports = __webpack_public_path__ + "img/txt02.0353588f.png";